'use strict'

const quickAccess =  {
    el: {
        scroll: 0
    },
    init: function(){
        quickAccess.setSticky();
    },
    setSticky: function() {
        let el = document.querySelector('.quickLinks');
        let breakpoint = document.querySelector('.header').offsetHeight + 50;
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if(el)
            st >= breakpoint ? el.classList.add('sticky') : el.classList.remove('sticky');
        
        quickAccess.el.last = st; // For Mobile or negative scrolling
    },
}


export default quickAccess;



// WEBPACK FOOTER //
// ./src/scripts/anims/quick-access.js